import angular from 'angular';

angular.module('commonServices', [
  'ngResource',
  'LocalStorageModule',
  'pascalprecht.translate',
  'cxHttpServices',
]);
